import TargetRolesFilterOperation from './components/TargetRolesFilter';

const tableSchemaBase = (t, clientLabel, expertLabel) => {
  return [
    {
      field: 'matricule',
      headerName: t('email_template.table.matricule'),
      type: 'smallText',
      hideable: false,
      minWidth: 100,
      maxWidth: 130,
      resizable: true,
      flex: 0.75,
      sortable: true,
      filterable: false,
      headerAlign: 'center',
      align: 'center',
    },
    // {
    //   field: 'scope',
    //   headerName: t('email_template.table.scope'),
    //   type: 'smallTextWithTooltip',
    //   hideable: false,
    //   minWidth: 150,
    //   maxWidth: 250,
    //   resizable: true,
    //   flex: 1,
    //   sortable: true,
    //   filterable: false,
    // },
    {
      field: 'title',
      headerName: t('email_template.table.title'),
      type: 'smallTextWithTooltip',
      hideable: false,
      minWidth: 200,
      maxWidth: 200,
      resizable: true,
      flex: 1,
      sortable: false,
      filterable: false,
    },
    {
      field: 'desc',
      headerName: t('email_template.table.description'),
      type: 'smallTextWithTooltip',
      hideable: false,
      minWidth: 170,
      resizable: true,
      flex: 1,
      sortable: false,
      filterable: false,
    },
    {
      field: 'targetRoles',
      headerName: t('email_template.table.target_roles'),
      type: 'smallText',
      hideable: false,
      minWidth: 120,
      resizable: true,
      flex: 0.5,
      sortable: false,
      filterable: true,
      filterOperators: TargetRolesFilterOperation(clientLabel, expertLabel),
    },
    {
      field: 'languages',
      headerName: t('email_template.table.available_languages'),
      type: 'smallTextWithTooltip',
      hideable: false,
      minWidth: 130,
      resizable: true,
      flex: 0.75,
      sortable: false,
      filterable: false,
    },
    {
      field: 'actionEditButton',
      headerName: t('email_template.table.action'),
      type: 'actionEditButton',
      hideable: false,
      minWidth: 100,
      resizable: true,
      flex: 0.75,
      sortable: false,
      filterable: false,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};

export { tableSchemaBase };
